import React, { useState } from 'react';
import { Card, Breadcrumb, Input, Row, Col, List, Spin, DatePicker, Button } from 'antd';
import Background from '../../../../static/img/bg-list-title.png';
import { queryApplicensesList } from './gqls'
import Client from '../../../../lib/gqlClient';
import moment from 'moment-timezone';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
const TrialInformation = (props) => {
    const navigate = useNavigate();
    const [isGetData, setIsGetData] = useState(false)
    const [seatchData, setSeatchData] = useState('')
    const [dataList, setDataList] = useState([])
    const [deivceListName, setDeivceListName] = useState([])
    const [startDate, setStartDate] = useState('')
    const [endDate, seteEndDate] = useState('')
    const [showSize, setShowSize] = useState(8)
    const [total, setTotal] = useState(1)
    const { RangePicker } = DatePicker;
    React.useEffect(() => {
        onSearch()
    }, [])
    function onInPut(value) {
        setSeatchData(value.target.value)
    }
    function onSearch() {
        getList(seatchData, 1, startDate, endDate,showSize)
    }
    function getList(value, page, startDate, endDate,count) {
        setIsGetData(true)
        if(count!==showSize){
            setShowSize(count)
        }
        Client(
            queryApplicensesList,
            {
                isPermanent: false,
                page: page,
                count: count,
                name: value,
                startDate: startDate,
                endDate: endDate
            }
        ).then((res) => {
            console.log(res)
            if (res !== null) {
                let list=['']
                res.data.getApplicensesList.data.map((item, index) => {
                    console.log(item.deviceList,item.deviceList.length)
                    let deviceName=''
                    item.deviceList.map((item2, index2) => {
                         deviceName=deviceName+item2+'\n'
                     })
                     list.push(deviceName)
                })
                setDataList(res.data.getApplicensesList.data)
                setDeivceListName(list)
                setTotal(res.data.getApplicensesList.total)
            }
            setIsGetData(false)
        }).catch(e => {
            // console.log(e);
            setIsGetData(false)
        })
    }

    function onChange(date, dateString) {
        console.log(date, dateString);
        if (date != null) {
            const start = moment(date[0]).valueOf()
            const end = moment(date[1]).valueOf()
            setStartDate(start)
            seteEndDate(end)
            getList(seatchData, 1, start, end,showSize)
        } else {
            setStartDate('')
            seteEndDate('')
            getList(seatchData, 1,'','',showSize)
        }


    }

    function onStart() {
        props.setNewKey('developerCenter/dataNotification')
        navigate('/developerCenter/dataNotification')

    }
    return (
        <div style={{ height: '100%', width: '100%', }}>

            {/* 标题头 */}
            <div style={{ height: '200px', padding: '0px', backgroundColor: 'white', borderRadius: '2px' }}>
                <Breadcrumb style={{ marginLeft: '20px', paddingTop: "6px" }}>
                    <Breadcrumb.Item><Link to='../../../home' style={{ fontSize: '12px' }}>首页</Link></Breadcrumb.Item>
                    <Breadcrumb.Item><a onClick={onStart} style={{ fontSize: '12px' }}>SDK Dashboard</a></Breadcrumb.Item>
                    <Breadcrumb.Item><a style={{ fontSize: '12px' }}>试用信息</a></Breadcrumb.Item>
                </Breadcrumb>
                <div style={Styles.title}>搜索试用信息</div>
                <Row style={Styles.search}>
                    <Col>
                        <div >
                            <Input
                                placeholder="请输入 Company Name\ Master Developer email address\App Name"
                                size="large"
                                style={{
                                    width: '556px',
                                    borderRadius: '2px',
                                    height: '46px'
                                }}
                                onChange={onInPut}
                                onPressEnter={onSearch}
                            />
                        </div></Col>
                    <Col>
                        <Button style={{ height: '46px', width: '80px', background: '#FF5300', color: 'white' }} onClick={onSearch}>搜索</Button>
                    </Col>
                </Row>

            </div>


            <Card bordered={false} style={{ marginTop: '25px', marginBottom: '25px', padding: '0px', }}>
                <div style={Styles.listTitle}>试用信息</div>
                <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'center', }}>
                    <RangePicker onChange={onChange} style={{ height: '32px', width: '256px', marginRight: '32px', }} />

                </div>
                <Row style={Styles.listTitleBg}>
                    <Col span={3} style={Styles.listTitleText}>
                        Company Name
                    </Col>
                    <Col span={5} style={Styles.listTitleText}>
                        Master Developer
                    </Col>
                    <Col span={4} style={Styles.listTitleText}>
                        App Name
                    </Col>
                    <Col span={2} style={Styles.listTitleText}>
                        Status
                    </Col>
                    <Col span={2} style={Styles.listTitleText}>
                        Solutions
                    </Col>
                    <Col span={2} style={Styles.listTitleText}>
                        Platform
                    </Col>
                    <Col span={3} style={Styles.listTitleText}>
                        License Trial Time
                    </Col>
                    {/* <Col span={2} style={Styles.listTitleText}>
                        Is Permanent
                    </Col> */}
                    <Col span={3} style={Styles.listTitleText}>
                        Device List
                    </Col>
                </Row>
                <Spin size="large" tip="Loading..." spinning={isGetData}>
                    <List
                        itemLayout="vertical"
                        split="true"
                        pagination={{
                            onChange: (page) => {
                                getList(seatchData, page, startDate,endDate,showSize)

                            },
                            pageSize: showSize,
                            hideOnSinglePage: true,
                            pageSizeOptions:[8,10,15,20,30,50,80,100],
                            onShowSizeChange: (current, pageSize) => {
                                getList(seatchData, current, startDate,endDate,pageSize)
                            },
                            total: total
                        }}
                        position="bottom"
                        dataSource={dataList}
                        renderItem={(item,index) => (
                            <List.Item >
                                <Row style={Styles.item}>
                                    <Col span={3} style={Styles.listItemText}>
                                        {item.company}
                                    </Col>
                                    <Col span={5} style={Styles.listItemText}>
                                        {item.developerEmail}
                                    </Col>
                                    <Col span={4} style={Styles.listItemText}>
                                        {item.appName}
                                    </Col>
                                    <Col span={2} style={Styles.listItemText}>
                                        {item.status}
                                    </Col>
                                    <Col span={2} style={Styles.listItemText}>
                                        {item.solutions}
                                    </Col>
                                    <Col span={2} style={Styles.listItemText}>
                                        {item.platform}
                                    </Col>
                                    <Col span={3} >
                                        <div style={{
                                            marginTop:'15px',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            fontSize: '14px',
                                            textAlign: 'center',
                                        }}>{String(item.licenseTrialRange).substring(0, 10)}</div>
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            fontSize: '14px',
                                            textAlign: 'center',
                                        }}>~</div>
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            fontSize: '14px',
                                            textAlign: 'center',
                                        }}>{String(item.licenseTrialRange).substring(13, 23)}</div>
                                        
                                        
                                    </Col>
                                    <Col span={3} style={Styles.listItemText}>
                                        {deivceListName[index+1]}
                                    </Col>
                                </Row>
                            </List.Item>
                        )}
                    />
                </Spin>
            </Card>

        </div>
    );

}

const Styles = {
    title: {
        display: 'block',
        fontSize: '20px',
        color: '#000000',
        marginLeft: '150px',
        marginTop: '30px'
    },
    search: {
        color: '#2D3238',
        height: '46px',
        marginTop: '30px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    listTitle: {
        display: 'block',
        fontSize: '16px',
        color: '#000000',
        marginTop: '25px',
        textAlign: 'center'

    },
    listTitleBg: {
        height: '54px',
        backgroundImage: `url(${Background})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100%, 100%',
        marginTop: '30px'
    },
    listTitleText: {
        height: '84px',
        fontSize: '14px',
        textAlign: 'center',
        marginTop: '16px'
    }, listItemText: {
        height: '84px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '14px',
        textAlign: 'center',
    },
    item: {
        height: '84px',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100%, 100%',
    }
}

export default TrialInformation